import { BasePresenter } from "core/presenter";

export default class SalesDataTablePresenter extends BasePresenter {
  initialState() {
    return {
      loading: false
    };
  }

  onShowCannotCancelReason(sale) {
    this.sendNotification({
      type: "error",
      title: "Atenção!",
      content:
        "Essa venda só pode ser cancelada pelo aplicativo, e com o SAT conectado!"
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/history/sales/data-table/presenter.js